export class ModalContactProd {
    constructor() {
      this.openBtns = {};
      this.closeBtn = {};
      this.modal = {};
    }

    init() {

      if (document.querySelectorAll('.js-modal-form-prod')[0]) {

        //this.modal = document.querySelector('.js-modal-form-prod');
        this.openBtns = document.querySelectorAll('.js-open-modal-form-prod');
        this.closeBtn = document.querySelector('.js-close-modal-form-prod');


        [].forEach.call(this.openBtns, function (elem) {
          
          elem.addEventListener('click', function () {
            console.log('dededede');

            let modal = document.querySelector('.js-modal-form-prod');
            if (modal.classList.contains('show')) {
              modal.classList.remove('show');
            }else{
              modal.classList.add('show');
            }
          });
        });

        this.closeBtn.addEventListener('click', function () {
          let modal = document.querySelector('.js-modal-form-prod');
          if (modal.classList.contains('show')) {
            modal.classList.remove('show');
          }else{
            modal.classList.add('show');
          }
        });
        
      }
    }

}